<template>
  <div class="text-left row">
    <div class="col-12">
      <div class="row">
        <div class="col-lg-6 col-sm-12 offset-lg-6 mb-2">
          <b-input-group>
            <the-mask
              id="search"
              @keypress.native.enter="listAll()"
              :mask="['(##) ####-####', '(##) #####-####']"
              v-model="filtro.search"
              class="form-control"
              placeholder="Pesquise um Número"
            />

            <b-input-group-append>
              <b-button variant="btn-sm btn-info" style="z-index: 0" @click="listAll()">
                <font-awesome-icon icon="search" class="pointer" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <div class="alert mt-4 alert-info col-12" v-if="filtro.search == ''">
        <strong>Atenção!</strong> Informe o número que você deseja buscar
      </div>
      <div class="alert mt-4 alert-warning col-12" v-else-if="resultfailed">
        <strong>Atenção!</strong> Nenhum número encontrado
      </div>

      <div
        class="mt-4 text-center col-12"
        v-if="lista.length > 0"
      >Mostrando 1 a {{mostrando}} de {{total}}</div>
      <div class="row mt-4">
        <div class="col">
          <table class="table table-dark table-striped table-sm table-responsive-lg">
            <thead class="thead-dark">
              <tr>
                <th width="130px" scope="col">Identificador do lote</th>
                <th width="130px" scope="col">Horario do envio</th>
                <th width="130px" scope="col">Número</th>
                <th width="130px" scope="col">Status de envio</th>
                <th width="130px" scope="col">Mensagem enviada</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in lista" :key="item._id">
                <td>{{item.identificadorLote | number}}</td>
                <td>{{item.dataHoraEnvio | datetime}}</td>
                <td>{{item.numero | phone}}</td>
                <td>{{item.status }}</td>
                <td>{{item.mensagem}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "home",
  data() {
    return {
      lista: [],
      total: 0,
      mostrando: 0,
      filtro: {
        search: ""
      },
      resultfailed: false,
    };
  },
  methods: {
    async listAll(skip, limit) {
      if (this.filtro.search) {
        let mySkip = skip ? skip : this.skip;
        let myLimit = limit ? limit : this.limit;

        let response = await this.$http.get(
          `/v1/v3/consultaCelular/${mySkip}/${myLimit}/${this.filtro.search}`
        );
        if (response.data) {
          this.lista = response.data;
          this.mostrando = response.totalFiltrado;
          this.total = response.total;
          if(response.total == 0){
            this.resultfailed = true;
          }else{
             this.resultfailed = false;
          }
        }
      }else{
        this.$toasted.show("Informe um número", { icon: "times", type: "error" });
      }
    }
  },
  async mounted() {
    this.listAll();
  }
};
</script>